import { useNavigate } from 'react-router-dom';
import { isRemoteIntialised } from '@mindtickle/ui-shell-core/DynamicRemote';
import useCheckRemoteInitialized from '~/components/GlobalHeader/Admin/hooks/useCheckRemoteInitialised';
import useCheckChatInitialized from '~/components/GlobalHeader/Admin/hooks/useCheckChatInitialized';
import { DYNAMIC_REMOTES } from '~/config/app.constants';
import { useBerryHelpers } from '@mindtickle/ui-shell-core/Berry';
import { useUserAuth } from '~/components/Auth';

const useHelpData = () => {
  const navigate = useNavigate();
  const berryActions = useBerryHelpers();
  const { isRemoteInitialized } = useCheckRemoteInitialized({
    defer: () => isRemoteIntialised(DYNAMIC_REMOTES.GET_SUPPORT.remoteName),
  });
  const {
    tempFeatureConfig: {
      isBerryChatDisabledForAdmin = false,
      isBerryChatDisabledForLearner = false,
    } = {},
  } = useUserAuth();

  const { isChatSupportReady } = useCheckChatInitialized({
    defer: () =>
      isBerryChatDisabledForAdmin ? !!(window?.fcWidget && window?.Berry) : !!window?.fcWidget,
  });

  return {
    isGetSupportInitialized: isRemoteInitialized,
    berryActions,
    navigate,
    isBerryChatDisabledForAdmin,
    isBerryChatDisabledForLearner,
    isChatSupportReady,
  };
};

export default useHelpData;
